@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_560_121_357)
public val Res.string.course_description: StringResource by lazy {
      StringResource("string:course_description", "course_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84500, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118012, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75167, 42),
      ))
    }

@delegate:ResourceContentHash(-347_546_465)
public val Res.string.course_draft_preview: StringResource by lazy {
      StringResource("string:course_draft_preview", "course_draft_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84535, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118051, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75210, 100),
      ))
    }

@delegate:ResourceContentHash(-146_258_773)
public val Res.string.course_drop_image: StringResource by lazy {
      StringResource("string:course_drop_image", "course_drop_image", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84644, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118220, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75311, 73),
      ))
    }

@delegate:ResourceContentHash(-158_462_948)
public val Res.string.course_drop_presentation: StringResource by lazy {
      StringResource("string:course_drop_presentation", "course_drop_presentation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84803, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118475, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75482, 108),
      ))
    }

@delegate:ResourceContentHash(-1_897_178_650)
public val Res.string.course_drop_presentation_pdf: StringResource by lazy {
      StringResource("string:course_drop_presentation_pdf", "course_drop_presentation_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84714, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118350, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75385, 96),
      ))
    }

@delegate:ResourceContentHash(955_669_262)
public val Res.string.course_due_days: StringResource by lazy {
      StringResource("string:course_due_days", "course_due_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84912, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118616, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75591, 51),
      ))
    }

@delegate:ResourceContentHash(-694_756_304)
public val Res.string.course_due_on: StringResource by lazy {
      StringResource("string:course_due_on", "course_due_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84972, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118688, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75643, 45),
      ))
    }

@delegate:ResourceContentHash(-1_417_778_036)
public val Res.string.course_edit: StringResource by lazy {
      StringResource("string:course_edit", "course_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85068, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118808, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75731, 27),
      ))
    }

@delegate:ResourceContentHash(889_585_097)
public val Res.string.course_edit_title: StringResource by lazy {
      StringResource("string:course_edit_title", "course_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85026, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118742, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75689, 41),
      ))
    }

@delegate:ResourceContentHash(-936_644_680)
public val Res.string.course_failed_attempts: StringResource by lazy {
      StringResource("string:course_failed_attempts", "course_failed_attempts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85096, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 118856, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75759, 94),
      ))
    }

@delegate:ResourceContentHash(1_971_919_855)
public val Res.string.course_failure_changed: StringResource by lazy {
      StringResource("string:course_failure_changed", "course_failure_changed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85199, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 119007, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75854, 94),
      ))
    }

@delegate:ResourceContentHash(788_152_069)
public val Res.string.course_failure_confirmation: StringResource by lazy {
      StringResource("string:course_failure_confirmation", "course_failure_confirmation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85310, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 119138, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75949, 111),
      ))
    }

@delegate:ResourceContentHash(-782_962_135)
public val Res.string.course_failure_no_attempts: StringResource by lazy {
      StringResource("string:course_failure_no_attempts", "course_failure_no_attempts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85418, 106),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 119290, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76061, 94),
      ))
    }

@delegate:ResourceContentHash(327_141_359)
public val Res.string.course_failure_not_ready: StringResource by lazy {
      StringResource("string:course_failure_not_ready", "course_failure_not_ready", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85525, 136),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 119441, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76156, 120),
      ))
    }

@delegate:ResourceContentHash(1_301_684_552)
public val Res.string.course_failure_nothing_to_confirm: StringResource by lazy {
      StringResource("string:course_failure_nothing_to_confirm", "course_failure_nothing_to_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85662, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 119622, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76277, 85),
      ))
    }

@delegate:ResourceContentHash(-637_079_141)
public val Res.string.course_failure_owner: StringResource by lazy {
      StringResource("string:course_failure_owner", "course_failure_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85752, 200),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 119748, 372),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76363, 204),
      ))
    }

@delegate:ResourceContentHash(1_033_430_933)
public val Res.string.course_failure_plan_ended: StringResource by lazy {
      StringResource("string:course_failure_plan_ended", "course_failure_plan_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 85953, 125),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 120121, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76568, 113),
      ))
    }

@delegate:ResourceContentHash(-1_420_347_296)
public val Res.string.course_failure_self_study: StringResource by lazy {
      StringResource("string:course_failure_self_study", "course_failure_self_study", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86079, 177),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 120295, 321),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76682, 149),
      ))
    }

@delegate:ResourceContentHash(-1_349_677_544)
public val Res.string.course_failure_test_not_passed: StringResource by lazy {
      StringResource("string:course_failure_test_not_passed", "course_failure_test_not_passed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86257, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 120617, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76832, 98),
      ))
    }

@delegate:ResourceContentHash(-822_279_533)
public val Res.string.course_finish: StringResource by lazy {
      StringResource("string:course_finish", "course_finish", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86368, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 120760, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76931, 29),
      ))
    }

@delegate:ResourceContentHash(68_266_216)
public val Res.string.course_for_roles: StringResource by lazy {
      StringResource("string:course_for_roles", "course_for_roles", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86402, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 120806, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76961, 60),
      ))
    }

@delegate:ResourceContentHash(-31_779_470)
public val Res.string.course_former: StringResource by lazy {
      StringResource("string:course_former", "course_former", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86467, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 120875, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77022, 49),
      ))
    }

@delegate:ResourceContentHash(1_836_573_177)
public val Res.string.course_image_added: StringResource by lazy {
      StringResource("string:course_image_added", "course_image_added", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86517, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 120949, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77072, 46),
      ))
    }

@delegate:ResourceContentHash(1_490_069_782)
public val Res.string.course_image_caption: StringResource by lazy {
      StringResource("string:course_image_caption", "course_image_caption", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86560, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 121020, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77119, 40),
      ))
    }

@delegate:ResourceContentHash(-272_742_792)
public val Res.string.course_image_invalid: StringResource by lazy {
      StringResource("string:course_image_invalid", "course_image_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86597, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 121065, 184),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77160, 104),
      ))
    }

@delegate:ResourceContentHash(1_863_923_347)
public val Res.string.course_instructor: StringResource by lazy {
      StringResource("string:course_instructor", "course_instructor", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86706, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 121250, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77265, 65),
      ))
    }

@delegate:ResourceContentHash(1_624_935_690)
public val Res.string.course_kind: StringResource by lazy {
      StringResource("string:course_kind", "course_kind", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88225, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 123665, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78576, 39),
      ))
    }

@delegate:ResourceContentHash(926_329_468)
public val Res.string.course_kind_general: StringResource by lazy {
      StringResource("string:course_kind_general", "course_kind_general", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86949, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 121609, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77496, 51),
      ))
    }

@delegate:ResourceContentHash(1_735_886_225)
public val Res.string.course_kind_general_hint: StringResource by lazy {
      StringResource("string:course_kind_general_hint", "course_kind_general_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 86784, 164),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 121340, 268),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77331, 164),
      ))
    }

@delegate:ResourceContentHash(1_182_304_274)
public val Res.string.course_kind_ohs_general: StringResource by lazy {
      StringResource("string:course_kind_ohs_general", "course_kind_ohs_general", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 87642, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 122770, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78077, 63),
      ))
    }

@delegate:ResourceContentHash(855_922_990)
public val Res.string.course_kind_ohs_general_hint: StringResource by lazy {
      StringResource("string:course_kind_ohs_general_hint", "course_kind_ohs_general_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 87001, 640),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 121705, 1064),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77548, 528),
      ))
    }

@delegate:ResourceContentHash(588_791_462)
public val Res.string.course_kind_ohs_periodic: StringResource by lazy {
      StringResource("string:course_kind_ohs_periodic", "course_kind_ohs_periodic", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88124, 100),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 123448, 216),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78487, 88),
      ))
    }

@delegate:ResourceContentHash(1_128_781_890)
public val Res.string.course_kind_ohs_periodic_hint: StringResource by lazy {
      StringResource("string:course_kind_ohs_periodic_hint", "course_kind_ohs_periodic_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 87706, 417),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 122894, 553),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78141, 345),
      ))
    }

@delegate:ResourceContentHash(-1_923_371_460)
public val Res.string.course_lesson_hours: StringResource by lazy {
      StringResource("string:course_lesson_hours", "course_lesson_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88366, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 123846, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78717, 75),
      ))
    }

@delegate:ResourceContentHash(-1_192_155_966)
public val Res.string.course_lesson_hours_hint: StringResource by lazy {
      StringResource("string:course_lesson_hours_hint", "course_lesson_hours_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88261, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 123709, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78616, 100),
      ))
    }

@delegate:ResourceContentHash(-964_388_244)
public val Res.string.course_move_down: StringResource by lazy {
      StringResource("string:course_move_down", "course_move_down", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88458, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 123982, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78793, 36),
      ))
    }

@delegate:ResourceContentHash(-1_843_872_676)
public val Res.string.course_move_up: StringResource by lazy {
      StringResource("string:course_move_up", "course_move_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88503, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124051, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78830, 34),
      ))
    }

@delegate:ResourceContentHash(-1_892_486_754)
public val Res.string.course_multi: StringResource by lazy {
      StringResource("string:course_multi", "course_multi", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88546, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124118, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78865, 56),
      ))
    }

@delegate:ResourceContentHash(1_020_387_605)
public val Res.string.course_new: StringResource by lazy {
      StringResource("string:course_new", "course_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88656, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124280, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78963, 34),
      ))
    }

@delegate:ResourceContentHash(1_020_387_605)
public val Res.string.course_new_title: StringResource by lazy {
      StringResource("string:course_new_title", "course_new_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88619, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124227, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78922, 40),
      ))
    }

@delegate:ResourceContentHash(-331_478_035)
public val Res.string.course_next: StringResource by lazy {
      StringResource("string:course_next", "course_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88687, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124327, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78998, 27),
      ))
    }

@delegate:ResourceContentHash(-782_962_135)
public val Res.string.course_no_attempts_today: StringResource by lazy {
      StringResource("string:course_no_attempts_today", "course_no_attempts_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88715, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124359, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79026, 92),
      ))
    }

@delegate:ResourceContentHash(813_967_209)
public val Res.string.course_not_started: StringResource by lazy {
      StringResource("string:course_not_started", "course_not_started", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88820, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124508, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79119, 42),
      ))
    }

@delegate:ResourceContentHash(766_166_324)
public val Res.string.course_ohs_conducted_by: StringResource by lazy {
      StringResource("string:course_ohs_conducted_by", "course_ohs_conducted_by", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88867, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124567, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79162, 55),
      ))
    }

@delegate:ResourceContentHash(1_128_370_299)
public val Res.string.course_ohs_consultation: StringResource by lazy {
      StringResource("string:course_ohs_consultation", "course_ohs_consultation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88923, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124631, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79218, 75),
      ))
    }

@delegate:ResourceContentHash(-832_744_437)
public val Res.string.course_ohs_details: StringResource by lazy {
      StringResource("string:course_ohs_details", "course_ohs_details", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 88991, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124735, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79294, 42),
      ))
    }

@delegate:ResourceContentHash(-945_226_346)
public val Res.string.course_ohs_general_confirm: StringResource by lazy {
      StringResource("string:course_ohs_general_confirm", "course_ohs_general_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89054, 242),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 124818, 366),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79337, 210),
      ))
    }

@delegate:ResourceContentHash(-1_093_810_807)
public val Res.string.course_ohs_hours: StringResource by lazy {
      StringResource("string:course_ohs_hours", "course_ohs_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89297, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125185, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79548, 60),
      ))
    }

@delegate:ResourceContentHash(-76_524_760)
public val Res.string.course_ohs_station_note: StringResource by lazy {
      StringResource("string:course_ohs_station_note", "course_ohs_station_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89370, 167),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125294, 267),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79609, 159),
      ))
    }

@delegate:ResourceContentHash(-689_852_712)
public val Res.string.course_open: StringResource by lazy {
      StringResource("string:course_open", "course_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89584, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125632, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79815, 27),
      ))
    }

@delegate:ResourceContentHash(-1_437_253_890)
public val Res.string.course_open_video: StringResource by lazy {
      StringResource("string:course_open_video", "course_open_video", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89538, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125562, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79769, 45),
      ))
    }

@delegate:ResourceContentHash(217_145_513)
public val Res.string.course_option: StringResource by lazy {
      StringResource("string:course_option", "course_option", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89616, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125676, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79843, 37),
      ))
    }

@delegate:ResourceContentHash(-468_982_325)
public val Res.string.course_overdue_since: StringResource by lazy {
      StringResource("string:course_overdue_since", "course_overdue_since", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89658, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125730, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79881, 52),
      ))
    }

@delegate:ResourceContentHash(-275_031_958)
public val Res.string.course_page_body: StringResource by lazy {
      StringResource("string:course_page_body", "course_page_body", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89715, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125799, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79934, 32),
      ))
    }

@delegate:ResourceContentHash(1_883_304_777)
public val Res.string.course_page_image: StringResource by lazy {
      StringResource("string:course_page_image", "course_page_image", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89752, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125840, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79967, 37),
      ))
    }

@delegate:ResourceContentHash(1_851_928_199)
public val Res.string.course_page_number: StringResource by lazy {
      StringResource("string:course_page_number", "course_page_number", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89786, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125894, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80005, 38),
      ))
    }

@delegate:ResourceContentHash(1_160_573_554)
public val Res.string.course_page_of: StringResource by lazy {
      StringResource("string:course_page_of", "course_page_of", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89829, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 125949, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80044, 46),
      ))
    }

@delegate:ResourceContentHash(-777_983_462)
public val Res.string.course_page_presentation: StringResource by lazy {
      StringResource("string:course_page_presentation", "course_page_presentation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89876, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126012, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80091, 48),
      ))
    }

@delegate:ResourceContentHash(-1_045_775_553)
public val Res.string.course_page_text: StringResource by lazy {
      StringResource("string:course_page_text", "course_page_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89925, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126077, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80140, 32),
      ))
    }

@delegate:ResourceContentHash(-1_725_321_913)
public val Res.string.course_page_title: StringResource by lazy {
      StringResource("string:course_page_title", "course_page_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 89958, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126118, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80173, 41),
      ))
    }

@delegate:ResourceContentHash(882_928_585)
public val Res.string.course_page_video: StringResource by lazy {
      StringResource("string:course_page_video", "course_page_video", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90004, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126192, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80215, 41),
      ))
    }

@delegate:ResourceContentHash(-1_384_940_569)
public val Res.string.course_pages: StringResource by lazy {
      StringResource("string:course_pages", "course_pages", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90120, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126360, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80315, 28),
      ))
    }

@delegate:ResourceContentHash(813_473_884)
public val Res.string.course_pages_seen: StringResource by lazy {
      StringResource("string:course_pages_seen", "course_pages_seen", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90050, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126266, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80257, 57),
      ))
    }

@delegate:ResourceContentHash(1_810_381_432)
public val Res.string.course_pass_percent: StringResource by lazy {
      StringResource("string:course_pass_percent", "course_pass_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90149, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126405, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80344, 39),
      ))
    }

@delegate:ResourceContentHash(-463_338_836)
public val Res.string.course_passed_on: StringResource by lazy {
      StringResource("string:course_passed_on", "course_passed_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90201, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126469, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80384, 60),
      ))
    }

@delegate:ResourceContentHash(-1_020_918_000)
public val Res.string.course_passed_with: StringResource by lazy {
      StringResource("string:course_passed_with", "course_passed_with", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90270, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126566, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80445, 50),
      ))
    }

@delegate:ResourceContentHash(1_142_111_987)
public val Res.string.course_pick_all: StringResource by lazy {
      StringResource("string:course_pick_all", "course_pick_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90333, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126657, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80496, 55),
      ))
    }

@delegate:ResourceContentHash(-1_433_550_216)
public val Res.string.course_pick_one: StringResource by lazy {
      StringResource("string:course_pick_one", "course_pick_one", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90409, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126757, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80552, 47),
      ))
    }

@delegate:ResourceContentHash(1_506_292_463)
public val Res.string.course_presentation_file_note: StringResource by lazy {
      StringResource("string:course_presentation_file_note", "course_presentation_file_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90469, 113),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 126837, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80600, 85),
      ))
    }

@delegate:ResourceContentHash(1_506_466_977)
public val Res.string.course_presentation_invalid: StringResource by lazy {
      StringResource("string:course_presentation_invalid", "course_presentation_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90583, 135),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 127003, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80686, 127),
      ))
    }

@delegate:ResourceContentHash(1_484_404_400)
public val Res.string.course_presentation_link: StringResource by lazy {
      StringResource("string:course_presentation_link", "course_presentation_link", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 91717, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 128561, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81728, 64),
      ))
    }

@delegate:ResourceContentHash(1_309_495_445)
public val Res.string.course_presentation_link_hint: StringResource by lazy {
      StringResource("string:course_presentation_link_hint", "course_presentation_link_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90719, 177),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 127183, 209),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80814, 157),
      ))
    }

@delegate:ResourceContentHash(1_449_580_523)
public val Res.string.course_presentation_link_not_https: StringResource by lazy {
      StringResource("string:course_presentation_link_not_https", "course_presentation_link_not_https", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 90897, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 127393, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 80972, 94),
      ))
    }

@delegate:ResourceContentHash(-1_660_333_113)
public val Res.string.course_presentation_link_not_presentation: StringResource by lazy {
      StringResource("string:course_presentation_link_not_presentation", "course_presentation_link_not_presentation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 91000, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 127536, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81067, 109),
      ))
    }

@delegate:ResourceContentHash(-99_922_904)
public val Res.string.course_presentation_link_opens: StringResource by lazy {
      StringResource("string:course_presentation_link_opens", "course_presentation_link_opens", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 91102, 142),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 127666, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81177, 146),
      ))
    }

@delegate:ResourceContentHash(1_191_057_081)
public val Res.string.course_presentation_link_shown: StringResource by lazy {
      StringResource("string:course_presentation_link_shown", "course_presentation_link_shown", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 91245, 226),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 127885, 358),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81324, 194),
      ))
    }

@delegate:ResourceContentHash(235_867_606)
public val Res.string.course_presentation_link_unsupported: StringResource by lazy {
      StringResource("string:course_presentation_link_unsupported", "course_presentation_link_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 91472, 244),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 128244, 316),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81519, 208),
      ))
    }

@delegate:ResourceContentHash(-186_013_607)
public val Res.string.course_presentation_open: StringResource by lazy {
      StringResource("string:course_presentation_open", "course_presentation_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 91905, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 128833, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81904, 60),
      ))
    }

@delegate:ResourceContentHash(518_361_640)
public val Res.string.course_presentation_open_file: StringResource by lazy {
      StringResource("string:course_presentation_open_file", "course_presentation_open_file", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 91778, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 128658, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81793, 57),
      ))
    }

@delegate:ResourceContentHash(1_678_626_545)
public val Res.string.course_presentation_open_pdf: StringResource by lazy {
      StringResource("string:course_presentation_open_pdf", "course_presentation_open_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 91840, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 128752, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81851, 52),
      ))
    }

@delegate:ResourceContentHash(1_023_699_547)
public val Res.string.course_presentation_pdf: StringResource by lazy {
      StringResource("string:course_presentation_pdf", "course_presentation_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 92437, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 129561, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82404, 55),
      ))
    }

@delegate:ResourceContentHash(1_862_387_449)
public val Res.string.course_presentation_pdf_added: StringResource by lazy {
      StringResource("string:course_presentation_pdf_added", "course_presentation_pdf_added", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 91966, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 128918, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 81965, 61),
      ))
    }

@delegate:ResourceContentHash(-444_677_423)
public val Res.string.course_presentation_pdf_hint: StringResource by lazy {
      StringResource("string:course_presentation_pdf_hint", "course_presentation_pdf_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 92028, 292),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 128988, 420),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82027, 264),
      ))
    }

@delegate:ResourceContentHash(-1_964_007_521)
public val Res.string.course_presentation_pdf_invalid: StringResource by lazy {
      StringResource("string:course_presentation_pdf_invalid", "course_presentation_pdf_invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 92321, 115),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 129409, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82292, 111),
      ))
    }

@delegate:ResourceContentHash(1_983_911_569)
public val Res.string.course_presentation_privacy: StringResource by lazy {
      StringResource("string:course_presentation_privacy", "course_presentation_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 92493, 219),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 129633, 379),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82460, 191),
      ))
    }

@delegate:ResourceContentHash(1_704_073_326)
public val Res.string.course_presentation_remove: StringResource by lazy {
      StringResource("string:course_presentation_remove", "course_presentation_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 92776, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 130096, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82711, 42),
      ))
    }

@delegate:ResourceContentHash(-272_863_249)
public val Res.string.course_presentation_remove_pdf: StringResource by lazy {
      StringResource("string:course_presentation_remove_pdf", "course_presentation_remove_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 92713, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 130013, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82652, 58),
      ))
    }

@delegate:ResourceContentHash(1_330_580_344)
public val Res.string.course_presentation_show: StringResource by lazy {
      StringResource("string:course_presentation_show", "course_presentation_show", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 92819, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 130155, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82754, 68),
      ))
    }

@delegate:ResourceContentHash(-739_399_170)
public val Res.string.course_presentation_upload: StringResource by lazy {
      StringResource("string:course_presentation_upload", "course_presentation_upload", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93173, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 130669, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83088, 54),
      ))
    }

@delegate:ResourceContentHash(-1_471_421_963)
public val Res.string.course_presentation_upload_hint: StringResource by lazy {
      StringResource("string:course_presentation_upload_hint", "course_presentation_upload_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 92888, 231),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 130252, 359),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 82823, 211),
      ))
    }

@delegate:ResourceContentHash(-1_724_851_096)
public val Res.string.course_presentation_uploaded: StringResource by lazy {
      StringResource("string:course_presentation_uploaded", "course_presentation_uploaded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93120, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 130612, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83035, 52),
      ))
    }

@delegate:ResourceContentHash(-1_081_290_298)
public val Res.string.course_preview: StringResource by lazy {
      StringResource("string:course_preview", "course_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93228, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 130748, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83143, 34),
      ))
    }

@delegate:ResourceContentHash(1_218_432_725)
public val Res.string.course_problem_course_too_large: StringResource by lazy {
      StringResource("string:course_problem_course_too_large", "course_problem_course_too_large", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93263, 163),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 130795, 247),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83178, 151),
      ))
    }

@delegate:ResourceContentHash(421_611_955)
public val Res.string.course_problem_due_days: StringResource by lazy {
      StringResource("string:course_problem_due_days", "course_problem_due_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93427, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 131043, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83330, 107),
      ))
    }

@delegate:ResourceContentHash(-63_996_512)
public val Res.string.course_problem_image: StringResource by lazy {
      StringResource("string:course_problem_image", "course_problem_image", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93527, 88),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 131183, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83438, 84),
      ))
    }

@delegate:ResourceContentHash(-1_625_457_545)
public val Res.string.course_problem_no_pages: StringResource by lazy {
      StringResource("string:course_problem_no_pages", "course_problem_no_pages", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93616, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 131344, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83523, 63),
      ))
    }

@delegate:ResourceContentHash(-1_064_171_095)
public val Res.string.course_problem_ohs_hours: StringResource by lazy {
      StringResource("string:course_problem_ohs_hours", "course_problem_ohs_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93692, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 131456, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83587, 120),
      ))
    }

@delegate:ResourceContentHash(-996_432_693)
public val Res.string.course_problem_ohs_instructor: StringResource by lazy {
      StringResource("string:course_problem_ohs_instructor", "course_problem_ohs_instructor", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93809, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 131637, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83708, 93),
      ))
    }

@delegate:ResourceContentHash(489_259_143)
public val Res.string.course_problem_ohs_quiz: StringResource by lazy {
      StringResource("string:course_problem_ohs_quiz", "course_problem_ohs_quiz", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93895, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 131763, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83802, 79),
      ))
    }

@delegate:ResourceContentHash(1_184_542_904)
public val Res.string.course_problem_options: StringResource by lazy {
      StringResource("string:course_problem_options", "course_problem_options", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 93983, 134),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 131911, 238),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 83882, 106),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString10Resources(map: MutableMap<String, StringResource>) {
  map.put("course_description", Res.string.course_description)
  map.put("course_draft_preview", Res.string.course_draft_preview)
  map.put("course_drop_image", Res.string.course_drop_image)
  map.put("course_drop_presentation", Res.string.course_drop_presentation)
  map.put("course_drop_presentation_pdf", Res.string.course_drop_presentation_pdf)
  map.put("course_due_days", Res.string.course_due_days)
  map.put("course_due_on", Res.string.course_due_on)
  map.put("course_edit", Res.string.course_edit)
  map.put("course_edit_title", Res.string.course_edit_title)
  map.put("course_failed_attempts", Res.string.course_failed_attempts)
  map.put("course_failure_changed", Res.string.course_failure_changed)
  map.put("course_failure_confirmation", Res.string.course_failure_confirmation)
  map.put("course_failure_no_attempts", Res.string.course_failure_no_attempts)
  map.put("course_failure_not_ready", Res.string.course_failure_not_ready)
  map.put("course_failure_nothing_to_confirm", Res.string.course_failure_nothing_to_confirm)
  map.put("course_failure_owner", Res.string.course_failure_owner)
  map.put("course_failure_plan_ended", Res.string.course_failure_plan_ended)
  map.put("course_failure_self_study", Res.string.course_failure_self_study)
  map.put("course_failure_test_not_passed", Res.string.course_failure_test_not_passed)
  map.put("course_finish", Res.string.course_finish)
  map.put("course_for_roles", Res.string.course_for_roles)
  map.put("course_former", Res.string.course_former)
  map.put("course_image_added", Res.string.course_image_added)
  map.put("course_image_caption", Res.string.course_image_caption)
  map.put("course_image_invalid", Res.string.course_image_invalid)
  map.put("course_instructor", Res.string.course_instructor)
  map.put("course_kind", Res.string.course_kind)
  map.put("course_kind_general", Res.string.course_kind_general)
  map.put("course_kind_general_hint", Res.string.course_kind_general_hint)
  map.put("course_kind_ohs_general", Res.string.course_kind_ohs_general)
  map.put("course_kind_ohs_general_hint", Res.string.course_kind_ohs_general_hint)
  map.put("course_kind_ohs_periodic", Res.string.course_kind_ohs_periodic)
  map.put("course_kind_ohs_periodic_hint", Res.string.course_kind_ohs_periodic_hint)
  map.put("course_lesson_hours", Res.string.course_lesson_hours)
  map.put("course_lesson_hours_hint", Res.string.course_lesson_hours_hint)
  map.put("course_move_down", Res.string.course_move_down)
  map.put("course_move_up", Res.string.course_move_up)
  map.put("course_multi", Res.string.course_multi)
  map.put("course_new", Res.string.course_new)
  map.put("course_new_title", Res.string.course_new_title)
  map.put("course_next", Res.string.course_next)
  map.put("course_no_attempts_today", Res.string.course_no_attempts_today)
  map.put("course_not_started", Res.string.course_not_started)
  map.put("course_ohs_conducted_by", Res.string.course_ohs_conducted_by)
  map.put("course_ohs_consultation", Res.string.course_ohs_consultation)
  map.put("course_ohs_details", Res.string.course_ohs_details)
  map.put("course_ohs_general_confirm", Res.string.course_ohs_general_confirm)
  map.put("course_ohs_hours", Res.string.course_ohs_hours)
  map.put("course_ohs_station_note", Res.string.course_ohs_station_note)
  map.put("course_open", Res.string.course_open)
  map.put("course_open_video", Res.string.course_open_video)
  map.put("course_option", Res.string.course_option)
  map.put("course_overdue_since", Res.string.course_overdue_since)
  map.put("course_page_body", Res.string.course_page_body)
  map.put("course_page_image", Res.string.course_page_image)
  map.put("course_page_number", Res.string.course_page_number)
  map.put("course_page_of", Res.string.course_page_of)
  map.put("course_page_presentation", Res.string.course_page_presentation)
  map.put("course_page_text", Res.string.course_page_text)
  map.put("course_page_title", Res.string.course_page_title)
  map.put("course_page_video", Res.string.course_page_video)
  map.put("course_pages", Res.string.course_pages)
  map.put("course_pages_seen", Res.string.course_pages_seen)
  map.put("course_pass_percent", Res.string.course_pass_percent)
  map.put("course_passed_on", Res.string.course_passed_on)
  map.put("course_passed_with", Res.string.course_passed_with)
  map.put("course_pick_all", Res.string.course_pick_all)
  map.put("course_pick_one", Res.string.course_pick_one)
  map.put("course_presentation_file_note", Res.string.course_presentation_file_note)
  map.put("course_presentation_invalid", Res.string.course_presentation_invalid)
  map.put("course_presentation_link", Res.string.course_presentation_link)
  map.put("course_presentation_link_hint", Res.string.course_presentation_link_hint)
  map.put("course_presentation_link_not_https", Res.string.course_presentation_link_not_https)
  map.put("course_presentation_link_not_presentation", Res.string.course_presentation_link_not_presentation)
  map.put("course_presentation_link_opens", Res.string.course_presentation_link_opens)
  map.put("course_presentation_link_shown", Res.string.course_presentation_link_shown)
  map.put("course_presentation_link_unsupported", Res.string.course_presentation_link_unsupported)
  map.put("course_presentation_open", Res.string.course_presentation_open)
  map.put("course_presentation_open_file", Res.string.course_presentation_open_file)
  map.put("course_presentation_open_pdf", Res.string.course_presentation_open_pdf)
  map.put("course_presentation_pdf", Res.string.course_presentation_pdf)
  map.put("course_presentation_pdf_added", Res.string.course_presentation_pdf_added)
  map.put("course_presentation_pdf_hint", Res.string.course_presentation_pdf_hint)
  map.put("course_presentation_pdf_invalid", Res.string.course_presentation_pdf_invalid)
  map.put("course_presentation_privacy", Res.string.course_presentation_privacy)
  map.put("course_presentation_remove", Res.string.course_presentation_remove)
  map.put("course_presentation_remove_pdf", Res.string.course_presentation_remove_pdf)
  map.put("course_presentation_show", Res.string.course_presentation_show)
  map.put("course_presentation_upload", Res.string.course_presentation_upload)
  map.put("course_presentation_upload_hint", Res.string.course_presentation_upload_hint)
  map.put("course_presentation_uploaded", Res.string.course_presentation_uploaded)
  map.put("course_preview", Res.string.course_preview)
  map.put("course_problem_course_too_large", Res.string.course_problem_course_too_large)
  map.put("course_problem_due_days", Res.string.course_problem_due_days)
  map.put("course_problem_image", Res.string.course_problem_image)
  map.put("course_problem_no_pages", Res.string.course_problem_no_pages)
  map.put("course_problem_ohs_hours", Res.string.course_problem_ohs_hours)
  map.put("course_problem_ohs_instructor", Res.string.course_problem_ohs_instructor)
  map.put("course_problem_ohs_quiz", Res.string.course_problem_ohs_quiz)
  map.put("course_problem_options", Res.string.course_problem_options)
}
